import { Outlet } from "react-router";
import Header from "../../../component/layout/header";
import useNav from "../../../script/tabingNavArray";


const AccountDetailLayout = () => {
     const navList = useNav();
  let {accountDetailBottomNav, topAccountNav} = navList;
    return (
        <div className="webBody">
            <Header bottomTabs={accountDetailBottomNav} topTabs={topAccountNav} />
            <Outlet />
        </div>
    )
}

export default AccountDetailLayout;